import { OrderDetailsV6GetSuccessResponse } from 'types/order-details';
import BASE_FIXTURE from './GET-200-base-fixure';

const PICKUP_FIXTURE: OrderDetailsV6GetSuccessResponse = {
  ...BASE_FIXTURE,
  fulfill_method: 'pickup',
};

export default PICKUP_FIXTURE;
